import {
 Component,
 computed,
 DestroyRef,
 effect,
 ElementRef,
 inject,
 OnInit,
 ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { LoadingService } from '@shared/services/loading.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import { HotelInfoUiService } from '../../pages/accommodation-info/services/hotel-info-ui.service';
import { SearchResultUiService } from '../../pages/search-result/services/search-result-ui.service';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { LoginRegisterUiService } from '../../pages/login-register/login-register-ui.service';
import { sign } from 'crypto';
// import { OpentelemetryService } from '@core/services/opentelemetry.service';

@Component({
 template: ``,
})
export class AccommodationBaseClass {
 config: any;
 route = inject(ActivatedRoute);
 loadingService = inject(LoadingService);
 router = inject(Router);
 pdpUiService = inject(HotelInfoUiService);
 authService = inject(AuthService);
 searchBoxService = inject(SearchBoxService);
 searchResultUiService = inject(SearchResultUiService);
//  opentelemetryService = inject(OpentelemetryService);
 swiperService = inject(SwiperService);
 loginRegisterUiService = inject(LoginRegisterUiService);
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 notificationService = inject(NotificationService);
 isDatapickerOpen = computed(() => this.datepickerService._state());
 destroyRef = inject(DestroyRef);

 @ViewChild('comments', { static: true }) comments!: ElementRef;
 @ViewChild('host', { static: true }) host!: ElementRef;
 @ViewChild('generalinfo', { static: true }) generalinfo!: ElementRef;
 @ViewChild('rooms', { static: true }) rooms!: ElementRef;
 @ViewChild('facilities', { static: true }) facilities!: ElementRef;
 @ViewChild('rules', { static: true }) rules!: ElementRef;
 @ViewChild('faqs', { static: true }) faqs!: ElementRef;
 @ViewChild('distance', { static: true }) distance!: ElementRef;
 @ViewChild('map', { static: true }) map!: ElementRef;
 @ViewChild('calender', { static: true }) calender!: ElementRef;
 @ViewChild('back', { static: true }) back!: ElementRef;
 @ViewChild('similarHotelsSection') similarHotelsSection!: ElementRef;
 @ViewChild('similarHotelsSectionTop') similarHotelsSectionTop!: any;

 sections: {
  name: string;
  el: ElementRef;
 }[] = [];

 constructor() {
//   this.opentelemetryService.startSpan('Search pdp');
//   this.opentelemetryService.sendEvent('Search pdp', {
//    Session_Id: '',
//    'mobile phone': this.authService._userData()?.mobile,
//    First_track_id: '',
//    Destination: this.autocompleteService._selectedItem()?.name,
//    startDate: this.datepickerService._startDate(),
//    endDate: this.datepickerService._endDate(),
//   });
//   this.opentelemetryService.endSpan();
 }
}
